import { create } from 'zustand'

const TOKEN_KEY = 'tradescope_token'
const EXPIRY_KEY = 'tradescope_token_expiry'
const ROLE_KEY = 'tradescope_role'

const useAuth = create((set, get) => ({
  token: localStorage.getItem(TOKEN_KEY) || null,
  expiry: localStorage.getItem(EXPIRY_KEY) || null,
  role: localStorage.getItem(ROLE_KEY) || null,
  isAuthenticated: () => {
    const { token, expiry } = get()
    if (!token) return false
    if (expiry && Date.now() > Number(expiry)) {
      get().logout()
      return false
    }
    return true
  },
  isAdmin: () => get().role === 'admin',
  login: (token, expiresInSeconds, role) => {
    const expiry = Date.now() + expiresInSeconds * 1000
    localStorage.setItem(TOKEN_KEY, token)
    localStorage.setItem(EXPIRY_KEY, String(expiry))
    localStorage.setItem(ROLE_KEY, role || 'user')
    set({ token, expiry: String(expiry), role: role || 'user' })
  },
  logout: () => {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(EXPIRY_KEY)
    localStorage.removeItem(ROLE_KEY)
    // Clear filter cache to avoid stale data on next login
    localStorage.removeItem('tradescope_filter_cache')
    set({ token: null, expiry: null, role: null })
  },
}))

export default useAuth
